import React, { useState, useEffect, useRef } from 'react';
import { FaSearch, FaMicrophone } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './SearchBar.css';

const SearchBar = () => {
    const navigate = useNavigate();

    const [keyword, setKeyword] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [noResults, setNoResults] = useState(false);
    const [showVoiceModal, setShowVoiceModal] = useState(false);
    const recognitionRef = useRef(null);

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            if (keyword.trim().length >= 3) {
                fetchSuggestions();
            } else {
                setSuggestions([]);
                setNoResults(false);
            }
        }, 400);
        return () => clearTimeout(delayDebounce);
    }, [keyword]);

    const fetchSuggestions = async () => {
        try {
            setLoading(true);
            setNoResults(false);

            const query = `keyword=${encodeURIComponent(keyword.trim())}`;
            const response = await axios.get(`https://eleganzaestatesolutions.com/api/admin/search-property?${query}`);
            const properties = response.data?.data?.properties || [];

            if (properties.length === 0) {
                setSuggestions([]);
                setNoResults(true);
            } else {
                const titles = properties.map(p => ({
                    title: p.title,
                    state: p.state || 'Unknown',
                    id: p._id,
                }));
                setSuggestions(titles);
                setNoResults(false);
            }
        } catch (error) {
            console.error('Error fetching suggestions:', error);
            setNoResults(true);
        } finally {
            setLoading(false);
        }
    };

    const startVoiceRecognition = () => {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            alert("Speech Recognition not supported in this browser.");
            return;
        }

        if (!recognitionRef.current) {
            recognitionRef.current = new SpeechRecognition();
            recognitionRef.current.continuous = false;
            recognitionRef.current.interimResults = false;
            recognitionRef.current.lang = 'en-US';

            recognitionRef.current.onresult = (event) => {
                const transcript = event.results[0][0].transcript;
                setKeyword(transcript);
                setShowVoiceModal(false);
            };

            recognitionRef.current.onerror = (event) => {
                console.error("Speech recognition error:", event.error);
                setShowVoiceModal(false);
            };
        }

        recognitionRef.current.start();
    };

    const tabs = [
        { label: "All", query: null },
        { label: "Duplexe", query: "DUPLEX" },
        { label: "Apartment", query: "APARTMENT" },
        { label: "Commercial", query: "COMMERCIAL" },
        { label: "Plots/Land", query: "PLOT" },
        { label: "Villas", query: "VILLA" },
    ];



    return (
        <div className="search-container">
            <div className="tabs">
                {tabs.map(tab => (
                    <button
                        key={tab.label}
                        className={`tab-button ${tab.label === "All" ? 'active' : ''}`}
                        onClick={() => {
                            if (tab.query) {
                                navigate(`/buyPage?category=${encodeURIComponent(tab.query)}`);
                            } else {
                                navigate("/buyPage");
                            }
                        }}
                    >
                        {tab.label}
                    </button>
                ))}

            </div>

            <div className="search-bar-wrapper">
                <div className="search-bar">
                    <FaSearch className="icon" />
                    <input
                        type="text"
                        placeholder="Search properties..."
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                    />
                    <div className="icon-btns">
                        <button className="icon-btn" onClick={() => setShowVoiceModal(true)}>
                            <FaMicrophone className="icon" />
                        </button>
                    </div>
                    <button className="search-button" onClick={fetchSuggestions}>Search</button>
                </div>

                {loading && <div className="loader mt-2">Loading...</div>}
                {!loading && noResults && <div className="no-results mt-3">No property found</div>}

                {!loading && suggestions.length > 0 && (
                    <ul className="suggestions-list">
                        {suggestions.map((item, idx) => (
                            <li
                                key={idx}
                                className="suggestion-item"
                                onClick={() => {
                                    setKeyword(item.title);
                                    setSuggestions([]);
                                    window.location.href = `/propertyDescription/${item.id}`;
                                }}
                            >
                                <FaSearch className="suggestion-icon" />
                                <div className="suggestion-content">
                                    <div className="suggestion-title">{item.title}</div>
                                    <div className="suggestion-state">{item.state}</div>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>

            {showVoiceModal && (
                <div className="voice-modal-overlay">
                    <div className="voice-modal">
                        <button className="close-btn" onClick={() => setShowVoiceModal(false)}>×</button>
                        <h3>Listening...</h3>
                        <p className="try-saying">Click on the mic and speak</p>
                        <p className="example">“Find 2BHK flats in Bhopal”</p>
                        <div className="mic-btn" onClick={startVoiceRecognition}>
                            <FaMicrophone size={32} color="#fff" />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchBar;
